import React, { useState, useEffect } from "react";

/** Components */
import {
  Tabs,
  Tab,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
  TableFooter,
  ButtonGroup,
  Checkbox,
  Collapse,
  Button,
  TextField,
  Tooltip,
} from "@mui/material";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import SelectStatusButton from "../../commons/SelectStatusButton";
import { FilterBy } from "../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { postSync, getLTP, getSTP, getInventory, updateLTPStatus } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useTranslation } from "react-i18next";
import moment from "moment";

/** Hook */
import { usePagination } from "../../commons/customHook";
import { useDispatch } from "react-redux";

const LTP = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const [page, setPage, rowsPerPage, setRowsPerPage] = usePagination();
  /** Tabs
   * LTP: ltp
   * STP: stp
   */
  const [tab, setTab] = useState("ltp");
  const [data, setData] = useState(undefined);
  const [changeIds, setChangeIds] = useState([]);
  const [isSearchOpen, setSearchOpen] = useState(true);
  const [filter, setFilter] = useState({
    exp_inventory: null,
    imp_inventory: null,
    code: "",
  });
  const filterData = data?.filter(
    (item) =>
      (filter.exp_inventory ? item.from_inventory_id === filter.exp_inventory.id : true) &&
      (filter.imp_inventory ? filter.imp_inventory.id === item.to_inventory_id : true) &&
      (filter.code ? item.code?.contains(filter.code) : true)
  );

  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateLTPStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN MẪU PHIẾU VẬN CHUYỂN NỘI KHO"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tab === "ltp") {
      dispatch(setHeaderTitle("THÔNG TIN MẪU PHIẾU VẬN CHUYỂN NỘI KHO"));
      getLTP().then((res) => {
        if (res.code !== 200) return;
        try {
          setData(res.data);
        } catch {}
      });
    }
    if (tab === "stp") {
      dispatch(setHeaderTitle("THÔNG TIN MẪU PHIẾU VẬN CHUYỂN NGOẠI KHO"));
      getSTP().then((res) => {
        if (res.code !== 200) return;
        try {
          setData(res.data);
        } catch {}
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  useEffect(() => {
    setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  return (
    <div>
      <div align="right" style={{ justifyContent: "space-between", display: "flex", marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <Tabs
          value={tab}
          style={{ height: 40 }}
          onChange={(e, value) => {
            setTab(value);
          }}
        >
          <Tab label={t("LTP")} value={"ltp"} />
          <Tab label={t("STP")} value={"stp"} />
        </Tabs>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          {tab === "ltp" ? (
            <ButtonWithAPICall title="Lấy dữ liệu từ ERP" api={() => postSync({ object: "ltp" })} variant="outlined">
              <RefreshIcon />
            </ButtonWithAPICall>
          ) : (
            <ButtonWithAPICall title="Lấy dữ liệu từ ERP" api={() => postSync({ object: "stp" })} variant="outlined">
              <RefreshIcon />
            </ButtonWithAPICall>
          )}
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={isSearchOpen}>
        <TextField style={{ display: "inline-flex", margin: "5px", minWidth: 240 }} label={t("Code")} value={filter.code} onChange={(e) => setFilter((prev) => ({ ...prev, code: e.target.value }))} />
        <FilterBy
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getInventory({ status: 1 })}
          value={filter.exp_inventory}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, exp_inventory: newValue }))}
          label={t("Từ kho")}
        />
        <FilterBy
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getInventory({ status: 1 })}
          value={filter.imp_inventory}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, imp_inventory: newValue }))}
          label={t("Đến kho")}
        />
      </Collapse>

      {!data ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Code")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Từ kho")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Đến kho")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày tạo")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày hết hạn")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filterData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                return (
                  <TableRow key={row.id}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.code} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                      {row.from_wh_name}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                      {row.to_wh_name}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.created_at && moment(row.created_at).format("DD/MM/YYYY")} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.exp_date && moment(row.exp_date).format("DD/MM/YYYY")} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  count={filterData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(e, newPage) => setPage(newPage)}
                  onRowsPerPageChange={setRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default LTP;
